const calloutStyle = {
  section_wrapper: `landing_page_component_wrapper w-full flex flex-col items-center justify-center text-center container mx-auto !py-[30px] lg:!py-[50px]`,
  heading: `text-white font-Suisse font-[900] uppercase text-[20px] leading-[26px] max-w-[95%] tracking-normal [word-spacing:0.05em]
            screen-500:text-[24px] screen-500:leading-[32px]
            sm:text-[28px] sm:leading-[38px]
            md:text-[34px] md:leading-[44px] md:max-w-[800px]
            lg:text-[38px] lg:leading-[48px] lg:max-w-[950px]
            xl:text-[42px] xl:leading-[54px] xl:max-w-[1100px]`,
  highlight: `text-primaryHeading`,
  divider: `w-full max-w-[1100px] h-[1px] bg-dividerLine opacity-35 my-8 md:my-12`,
  stats_container: `grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 w-full max-w-[1100px] justify-items-center mt-2`,
  stat_item: `flex flex-col items-center justify-start text-center px-4 transition-all duration-300 hover:-translate-y-1 group`,
  stat_number: `text-primaryHeading font-Suisse font-[900] text-[48px] leading-[56px] screen-500:text-[56px] screen-500:leading-[64px] md:text-[64px] md:leading-[72px] lg:text-[76px] lg:leading-[84px] tracking-tight transition-transform duration-300 group-hover:scale-105 cursor-default`,
  stat_label: `text-white font-inter font-light text-[11px] leading-[16px] screen-500:text-[12px] screen-500:leading-[18px] md:text-[13px] md:leading-[20px] lg:text-[14px] lg:leading-[22px] tracking-wider max-w-[240px] mt-2 opacity-85 transition-opacity duration-300 group-hover:opacity-100`,
};

export { calloutStyle };

